// extracted by mini-css-extract-plugin
module.exports = {"container":"AboutMe_container__10xA6","containerText":"AboutMe_containerText__2BY6h"};